module.exports = __webpack_public_path__ + "img/checkmark.77497bf5.svg";